/*
 * Shopify Common JS
 * Ported from global.js from the old / original theme
 */

export const bind = function (
  fn: (...args: any[]) => any,
  scope: any,
  ...args: any[]
) {
  return function () {
    return fn.apply(scope, args)
  }
}

export const setSelectorByValue = function (
  selector: HTMLSelectElement,
  value: string,
) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

export class CountryProvinceSelector {
  countryEl: HTMLSelectElement
  provinceEl: HTMLSelectElement
  provinceContainer: HTMLElement

  constructor(
    countryDomId: string | HTMLSelectElement,
    provinceDomId: string | HTMLSelectElement,
    options: any,
  ) {
    const countryEl =
      typeof countryDomId === 'string'
        ? (document.getElementById(countryDomId) as HTMLSelectElement | null)
        : countryDomId
    const provinceEl =
      typeof provinceDomId === 'string'
        ? (document.getElementById(provinceDomId) as HTMLSelectElement | null)
        : provinceDomId
    const provinceContainer = document.getElementById(
      options['hideElement'] || provinceDomId,
    )

    if (!countryEl || !provinceEl || !provinceContainer) {
      throw new Error('Not all required HTML elements found!')
    }

    this.countryEl = countryEl
    this.provinceEl = provinceEl
    this.provinceContainer = provinceContainer

    this.countryEl.addEventListener(
      'change',
      bind(this.countryHandler, this),
      false,
    )

    this.initCountry()
    this.initProvince()
  }

  initCountry() {
    const value = this.countryEl.getAttribute('data-default')
    if (value) setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  }

  initProvince() {
    const value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      setSelectorByValue(this.provinceEl, value)
    }
  }

  countryHandler() {
    const opt = this.countryEl.options[this.countryEl.selectedIndex]
    const raw = opt.getAttribute('data-provinces')
    if (!raw) {
      throw new Error('data-provinces attribute has no value!')
    }
    const provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (let i = 0; i < provinces.length; i++) {
        const opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  }

  clearOptions(selector: HTMLSelectElement) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  }

  setOptions(selector: HTMLSelectElement, values: string[]) {
    for (let i = 0; i < values.length; i++) {
      const opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  }
}

/**
 * Retrieve the definitive market ID for the current page based on the market handle and (as fallback for legacy reasons) the Shopify country.
 * Also see `src/riba/constants.ts:marketHandleMap` for further information.
 */
export const getMarketId = () => {
  let marketId = document.body.dataset.market

  if (!marketId) {
    marketId = 'DE'
    console.error(`Could not retrieve market ID, falling back to ${marketId}`)
  }

  return marketId
}

/**
 * Check if the current market is in the allowlist
 * @param allowlist
 * @returns
 */
export const isInMarketAllowlist = (allowlist: string[]): boolean => {
  // If the allowlist is empty, we assume that the article is available for all markets
  if (allowlist.length === 0) {
    return true
  }
  return allowlist.includes(getMarketId())
}
